import styled, { css } from 'styled-components';
import {
  px2rem,
  getSpace,
  gridContainer,
  setGridColumns,
  mq,
  getColor
} from '../../../stylesheets/tools';

const StyledEventTeaserListItem = styled.div`
  ${props =>
    props.isNumbered &&
    css`
      display: flex;
    `}

  .card {
    width: 100%;
    position: relative;
    ${gridContainer()}
    ${setGridColumns('1fr', 1)}
    padding: ${px2rem('20px')};
    gap: ${px2rem('10px')};
      
    ${mq('l')} {
      ${setGridColumns('1fr', 10)}
    }
    &:hover,
    &:focus {
      cursor: pointer;
      background-position: top right, top right, bottom left, bottom left, top left;
      background-repeat: no-repeat;
      background-image: linear-gradient(180deg, currentColor, currentColor),
        linear-gradient(225deg, currentColor, currentColor),
        linear-gradient(0deg, currentColor, currentColor),
        linear-gradient(90deg, currentColor, currentColor),
        linear-gradient(
          135deg,
          transparent 18px,
          currentColor 18px,
          currentColor 20px,
          transparent 20px
        );
      background-size: calc(100% - 26px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 26px), 36px 36px;

      
      ${mq('l')} {
        background-image: linear-gradient(180deg, currentColor, currentColor),
          linear-gradient(225deg, currentColor, currentColor),
          linear-gradient(0deg, currentColor, currentColor),
          linear-gradient(90deg, currentColor, currentColor),
          linear-gradient(
            135deg,
            transparent 24px,
            currentColor 24px,
            currentColor 26px,
            transparent 26px
          );
        background-size: calc(100% - 34px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 34px), 36px 36px;
      }

      &:after {
        background-color: ${getColor('lightGray')};
        position: absolute;
        height: 100%;
        z-index: -2;
        width: 100%;
        content: '';
        clip-path: polygon(28px 0, 100% 0, 100% 100%, 0 100%, 0 28px);

        ${mq('m')} {
          clip-path: polygon(34px 0, 100% 0, 100% 100%, 0 100%, 0 34px);
        }
      }

      .card__date {
        .eventDate__shape {
          &:before {
            display: block;
          }
          &:after {
            display: none;
          }
        }
      }
    }

    &:hover .card__arrow {
      border-color: black !important;
    };


    .card__image {
      display: block;
      padding-top: ${px2rem('10px')};
      
      img {
        aspect-ratio: 16 / 9;
        object-fit: cover;
        max-width: 100%;
        width: 100%;
        height: 100%;
      }
        
      ${mq('l')} {
        grid-column: span 2 / span 2;
        max-width: 100%;
        padding-top: ${px2rem('20px')};
        
        img {
          aspect-ratio: 4 / 3;
        } 
      }
      ${mq('xl')} {
        display: none;
      }
    }

    .card__date {
      ${props =>
        props.noImage
          ? css`
              margin: 0 -35px -20px auto;
            `
          : css`
              margin: -60px -35px -20px auto;
            `}
      
      ${mq('l')} {
        margin: 0;
        ${props =>
          !props.noImage &&
          css`
            transform: translateX(-30px);
          `}
      }
        
      ${mq('xl')} {
        margin: 0;
        transform: unset;
        grid-column: span 2 / span 2;
        
        .eventDate__shape {
          &:before {
            display: none;
          }
          &:after {
            display: block;
          }
        }
      }
    }
    .card__content {
      display: flex;
      gap: ${px2rem('26px')};

      ${mq('l')} {
        ${mq('l')} {
          ${props =>
            props.noImage
              ? css`
                  grid-column: span 9 / span 9;
                `
              : css`
                  grid-column: span 7 / span 7;
                `}
        }
      }
      ${mq('xl')} {
        grid-column: span 8 / span 8;
      }

      .card__text {
        width: 100%;
        
        .card__time {
          display: block;
          margin-bottom: ${px2rem('4px')};
        }
        .card__headline {
          font-size: ${px2rem('20px')};
        }
        .card__copy {
          margin: ${px2rem('5px')} 0 0 0;
          color: ${getColor('teaserGray')};
          line-height: 1.75;
        }
        .card__stretched-link {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
        }
      }
      .card__arrow {
        display: none;

        ${mq('l')} {
          border-left: 2px solid ${getColor('gray')};
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 ${getSpace('xxs')} 0 ${getSpace('s')};
        }
      }
    }
  }
`;

export default StyledEventTeaserListItem;
